import { useState, useEffect } from "react";
import { HashLink } from "react-router-hash-link";
import "./Navbar.css";

function MenuIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  );
}

function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    >
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
}

const NAV_LINKS = [
  { label: "About", to: "/#herobanner", sectionId: "herobanner" },
  { label: "Work", to: "/#MY WORK", sectionId: "MY WORK" },
  { label: "Article", to: "/#ARTICLE", sectionId: "ARTICLE" },
  { label: "Contact", to: "/#footer", sectionId: "footer" },
];

function Navbar() {
  const [open, setOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("herobanner");

  useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("resize", close);
    return () => window.removeEventListener("resize", close);
  }, []);

  useEffect(() => {
    const ids = NAV_LINKS.map((l) => l.sectionId);
    const handleScroll = () => {
      const scrollY = window.scrollY + 80;
      let current = ids[0];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= scrollY) current = id;
      });
      setActiveSection(current);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <nav className="navbar">
        <div className="navbar__inner">
          <HashLink to="/" aria-label="Home">
            <img
              src={`${process.env.PUBLIC_URL}/navbaricon.svg`}
              alt="Vo"
              className="navbar__logo-img"
            />
          </HashLink>

          <ul className="navbar__links">
            {NAV_LINKS.map(({ label, to, sectionId }) => (
              <li key={label}>
                <HashLink
                  to={to}
                  smooth
                  className={activeSection === sectionId ? "active" : ""}
                >
                  {label}
                </HashLink>
              </li>
            ))}
          </ul>

          <button
            className="navbar__hamburger"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen(!open)}
          >
            {open ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="navbar__mobile-menu" onClick={() => setOpen(false)}>
          {NAV_LINKS.map(({ label, to, sectionId }) => (
            <HashLink
              key={label}
              to={to}
              smooth
              className={activeSection === sectionId ? "active" : ""}
            >
              {label}
            </HashLink>
          ))}
        </div>
      )}
    </>
  );
}

export default Navbar;
